export default {
  INIT_WELCOME_TOUR: '@WS_EDITOR/INIT_WELCOME_TOUR',
};
